import { render } from "./App.vue?vue&type=template&id=0a731db0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0a731db0&lang=scss"
script.render = render

export default script